import { DocumentRenderer } from '@keystone-6/document-renderer'
import Text from '@/components/Text'
import { DotIcon } from 'lucide-react'
import { ReactNode } from 'react'
import { match } from 'ts-pattern'

export default function ThemedDocumentRenderer({
  document,
}: {
  document: any
}) {
  return (
    <DocumentRenderer
      document={document as any}
      renderers={{
        block: {
          paragraph: ({ children }) => (
            <Text variant="body2" className="mb-2">
              {children}
            </Text>
          ),
          list: ({ children }) => (
            <div className="flex flex-col mb-2">
              {children.map((c, i) => (
                <ListItem key={i} node={c} />
              ))}
            </div>
          ),
          heading: ({ level, children }) =>
            match(level)
              .with(1, () => <Text variant={'h1'}> {children} </Text>)
              .with(2, () => <Text variant={'h2'}> {children} </Text>)
              .with(3, () => <Text variant={'h3'}> {children} </Text>)
              .with(4, () => <Text variant={'h3-subheader'}> {children} </Text>)
              .with(5, () => <Text variant={'h3-subheader'}> {children} </Text>)
              .with(6, () => <Text variant={'h3-subheader'}> {children} </Text>)
              .exhaustive(),
        },
      }}
    />
  )
}

const ListItem = (props: { node: ReactNode }) => (
  <Text variant="body2" className="flex flex-row items-start">
    <DotIcon size={24} className="flex-none inline-block -translate-y-0.5" />{' '}
    {props.node}
  </Text>
)
